/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Breadcrumb } from 'matx';
import { Icon, Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { getOutletsList, GET_OUTLET_LIST } from 'app/redux/actions/OutletActions';

import OutletTable from './shared/OutletTable';

const Outlets = (props) => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch({
      type: GET_OUTLET_LIST,
      payload: []
    });
    
    dispatch(getOutletsList());
  }, []);

  return (
    <div className="m-sm-30 menu">
      <div className="mb-sm-30 flex items-center justify-between">
        <Breadcrumb
          routeSegments={[
            { name: 'Outlets', path: '/outlets/list' },
            { name: 'List' }
          ]}
        />
        <div className="">
          <Button
            component={RouterLink}
            to="/outlets/add"
            variant="contained"
            color="primary"
            endIcon={<Icon>add</Icon>}
          >
            Add New
          </Button>
        </div>
      </div>
      <OutletTable />
    </div>
  );
};

export default Outlets;
